const x = `
  <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x" fill="#e06935" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
  </svg>
`;

$(document).ready((e) => {
  const allRecipesField = $("#all_recipes");
  if (allRecipesField) {
    let selectedTags = [];
    const toggleTag = (e) => {
      let { textContent: tag } = e.currentTarget;
      tag = tag.trim();
      const tagElement = $(`.recipe-tag-btn:contains("${tag}")`);
      if (selectedTags.includes(tag)) {
        selectedTags = selectedTags.filter((t) => t !== tag);
        tagElement.removeClass("badge-orange");
        tagElement.addClass("badge-green-4");
      } else {
        selectedTags.push(tag);
        tagElement.removeClass("badge-green-4");
        tagElement.addClass("badge-orange");
      }
      const recipeCards = $(".recipe-card");
      if (selectedTags.length > 0) {
        $(".recipes-title").html(
          selectedTags.reduce((html, tag) => {
            html += `<span role="button" class="toggle-tag"><u>${tag}</u><span">${x}</span></span>`;
            return html;
          }, "<span>Recipes for </span>")
        );
        $(".toggle-tag").on("click", toggleTag);
      } else {
        $(".recipes-title").text("Recipes");
      }
      recipeCards.each(function () {
        const recipeTags = $.makeArray($(this).find(".recipe-tag")).map((t) =>
          $(t).text()
        );
        if (selectedTags.every((t) => recipeTags.includes(t))) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    };
    const allRecipes = JSON.parse(allRecipesField.val());
    $(".recipe-tag-btn").on("click", toggleTag);
  }
});
